import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductCardLocationQuantityLineFragmentDoc = gql`
  fragment ProductCardLocationQuantityLine on RequisitionLine {
    id
    stockLevelParLevel
    stockLevelQuantity
  }
` as unknown as DocumentNode<Types.ProductCardLocationQuantityLineFragment, unknown>
